var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash.get';
/** adds and removes event listeners, must 'bind' to component  */
export function handleDimensionEvent() {
    var listenerCallback = setDimsAndOrientation.bind(this);
    return {
        // window may not be available in all testing environments
        eventAvailable: typeof window !== 'undefined' &&
            !!window.addEventListener &&
            !!window.removeEventListener,
        // call in componentDidMount
        addDimensionEventListener: function () {
            window.addEventListener('resize', listenerCallback);
        },
        // call in componentWillUnmount
        removeDimensionEventListener: function () {
            window.removeEventListener('resize', listenerCallback);
        }
    };
}
/** returns breakpoints object with dimensions and orientation */
export function processPropertiesForState(breakpoints) {
    var windowObject = typeof window !== 'undefined' ? window : undefined;
    return __assign(__assign(__assign(__assign({}, windowOrientationProperties(windowObject)), screenProperties(windowObject)), sizeProperties(breakpoints, windowObject)), checkSsrEnv(breakpoints));
}
function setDimsAndOrientation(_event) {
    this.setState(processPropertiesForState(this.getCurrentBreakpoints()));
}
/** get orientation of actual hardware screen */
function screenProperties(target) {
    var orientationType = get(target, 'screen.orientation.type', undefined);
    var widthScreen = get(target, 'screen.width', undefined);
    var heightScreen = get(target, 'screen.height', undefined);
    var landscapeScreen = orientationType === 'landscape-primary' ||
        orientationType === 'landscape-secondary';
    var portraitScreen = orientationType === 'portrait-primary' ||
        orientationType === 'portrait-secondary';
    if (landscapeScreen || portraitScreen) {
        return __assign(__assign({ landscapeScreen: landscapeScreen,
            portraitScreen: portraitScreen }, (widthScreen && { widthScreen: widthScreen })), (heightScreen && { heightScreen: heightScreen }));
    }
    return __assign(__assign({}, (widthScreen && { widthScreen: widthScreen })), (heightScreen && { heightScreen: heightScreen }));
}
function windowOrientationProperties(target) {
    if (target && target.matchMedia) {
        var portraitWindow = target.matchMedia('all and (orientation: portrait)')
            .matches;
        var landscapeWindow = target.matchMedia('all and (orientation: landscape)').matches;
        if (portraitWindow || landscapeWindow) {
            return {
                portraitWindow: portraitWindow,
                landscapeWindow: landscapeWindow
            };
        }
    }
    return {};
}
function sizeProperties(breakpoints, windowObject) {
    if (windowObject === null || windowObject === void 0 ? void 0 : windowObject.matchMedia) {
        var s = breakpoints.s, m = breakpoints.m, l = breakpoints.l, xl = breakpoints.xl;
        var innerHeight_1 = windowObject.innerHeight, innerWidth_1 = windowObject.innerWidth;
        var match = function (cssString) {
            return windowObject.matchMedia('all and ' + cssString).matches;
        };
        var isXL = match("(min-width: " + xl + "px)");
        var isL = !isXL && match("(min-width: " + l + "px) and (max-width: " + xl + "px)");
        var isM = !isL && match("(min-width: " + m + "px) and (max-width: " + l + "px)");
        var isS = !isM && match("(min-width: " + s + "px) and (max-width: " + m + "px)");
        var isDefaultSize = !innerWidth_1 || match("(max-width: " + s + "px)");
        return __assign(__assign(__assign({}, (innerHeight_1 ? { heightWindow: innerHeight_1 } : {})), (innerWidth_1 ? { widthWindow: innerWidth_1 } : {})), { isDefaultSize: isDefaultSize,
            isS: isS,
            isM: isM,
            isL: isL,
            isXL: isXL });
    }
    return {};
}
function checkSsrEnv(_a) {
    var ssrSize = _a.ssrSize;
    /* `window` object is 'undefined' when server-side rendering with Next.js.
    Here that condition is used to infer SSR. */
    var isSsr = typeof window === 'undefined';
    if (isSsr) {
        switch (ssrSize) {
            case 'defaultSize':
                return { isDefaultSize: true, isSsr: isSsr };
            case 's':
                return { isS: true, isSsr: isSsr };
            case 'm':
                return { isM: true, isSsr: isSsr };
            case 'l':
                return { isL: true, isSsr: isSsr };
            case 'xl':
                return { isXL: true, isSsr: isSsr };
            default:
                break;
        }
    }
    return {};
}
